import { useState, useEffect } from "react";
import {
  getScreenSize,
  getResponsiveSpacing,
  getResponsiveFontSizes,
  getResponsiveContainer,
  getResponsiveGrid,
} from "../styles/payrollStyles";

const useResponsive = () => {
  const [screenSize, setScreenSize] = useState(getScreenSize());
  const [spacing, setSpacing] = useState(getResponsiveSpacing(screenSize));
  const [fonts, setFonts] = useState(getResponsiveFontSizes(screenSize));
  const [container, setContainer] = useState(
    getResponsiveContainer(screenSize),
  );
  const [gridCols, setGridCols] = useState(getResponsiveGrid(screenSize));

  // NOTE: moved modal body-scroll locking effect down below (after modal state declarations)

  useEffect(() => {
    const handleResize = () => {
      const newScreenSize = getScreenSize();
      setScreenSize(newScreenSize);
      setSpacing(getResponsiveSpacing(newScreenSize));
      setFonts(getResponsiveFontSizes(newScreenSize));
      setContainer(getResponsiveContainer(newScreenSize));
      setGridCols(getResponsiveGrid(newScreenSize));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { screenSize, spacing, fonts, container, gridCols };
};

export default useResponsive;